<template>
<div>
</div>
</template>

<script>
import {getUserInfo} from '@/api/home.js'
export default {
    name: 'mbsso',

    created() {
        let token = this.$route.query.token;
        localStorage.setItem("nstoken", token);
        getUserInfo().then(res => {
            localStorage.setItem('meausout',JSON.stringify(res.data.data.menus))
            res.data.data.userInfo.parentName = res.data.data.parentName
            let meaurouter = this.getmewaucode(res.data.data.menus)
            let newmeaus = res.data.data.menus
            let ConfigurationCentermeau = []
            newmeaus.forEach(item => {
                if (item.resCode == "ConfigurationCenter") {
                    ConfigurationCentermeau = JSON.parse(JSON.stringify(item)).children
                    item.children = []
                }
            })
            localStorage.setItem("resources",JSON.stringify(res.data.data.resources))
            localStorage.setItem("meaurouter", meaurouter)
            localStorage.setItem("meaus", JSON.stringify(newmeaus) )
            localStorage.setItem("ConfigurationCentermeau", JSON.stringify(ConfigurationCentermeau))
            localStorage.setItem("userInfo", JSON.stringify(res.data.data.userInfo))
            localStorage.setItem("userRoles", JSON.stringify(res.data.data.roles))
            localStorage.setItem("suosq", res.data.data.suosq)
            this.$router.push('/home')
        }).catch((error) => {
        })
    },
    methods:{
        getmewaucode(list) {
            var meaurouter = []

            function getmewaucode(list) {
                list.forEach(item => {
                    if (item.resCode) {
                        meaurouter.push(item.resCode)
                    }
                    if (item.children && item.children.length > 0) {
                        getmewaucode(item.children)
                    }
                })
            }
            getmewaucode(list)
            return meaurouter
        },
    }
};
</script>

<style scoped>

</style>